module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="filter_button"><span id="sort_filter_button">' +
((__t = ( getDropDownText() )) == null ? '' : __t) +
'</span></div>\n<ul class="filter_dropdown">\n	<li class="dropdown_list_item default" id="sort_default" data-attr="default" data-text="default" dropdown-value="default"></li>\n	';
 if(sortRecencyEnabled()) { ;
__p += '\n	<li class="dropdown_list_item sort_recency" id="sort_recency" data-attr="sortByRecency" data-text="sort_recency" dropdown-value="most recent"></li>\n	';
 } ;
__p += '\n	';
 if(sortPopularEnabled()) { ;
__p += '\n	<li class="dropdown_list_item sort_popularity" id="sort_popularity" data-attr="sortByPopularity" data-text="sort_popularity" dropdown-value="most popular"></li>\n	';
 } ;
__p += '\n	';
 if(sortPriceEnabled()) { ;
__p += '\n	<li class="dropdown_list_item " id="sort_price_high_low" data-attr="" data-text="" dropdown-value="price | high to low"></li>\n	<li class="dropdown_list_item " id="sort_price_low_high" data-attr="" data-text="" dropdown-value="price | low to high"></li>\n	';
 } ;
__p += '\n</ul>';

}
return __p
}